import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ViewAllCompanies } from './view-all-companies/view-all-companies';

@Component({
  selector: 'app-admin-companies',
  imports: [RouterModule],
  templateUrl: './admin-companies.html',
  styleUrl: './admin-companies.scss',
})
export class AdminCompanies {}
